<div class="wrapper">
  <div class="container">
    <div class="page-header"><h2 class="heading">セキュリティ設定</h2></div>
    <section class="section">
      <h3 class="section-heading">多要素認証</h3>
      @if (loadFailed) {
        <button rectangle (click)="refresh()">再読み込み</button>
      } @else if (status === null) {
        <app-loading [showLoading]="true"></app-loading>
      }
      @if (status; as current) {
        <h4>現在の設定</h4>
        <div class="status">
          <p>
            {{
              current.requiredByOrg
                ? '必須(組織の設定)'
                : current.requiredByUser
                  ? '必須(あなたの設定)'
                  : '任意'
            }}
          </p>
          <p>
            {{
              current.requiredForUser
                ? 'ログインには二要素認証が必要です'
                : '登録すると、ログイン時に二要素認証が求められます。登録は任意です'
            }}
          </p>
        </div>
        <h4>登録済み手段</h4>
        <div class="methods">
          @for (method of current.methods; track method.id) {
            <article class="method">
              <div>
                <h5>
                  {{
                    method.type === 'PASSKEY'
                      ? 'パスキー'
                      : method.type === 'SMS'
                        ? 'SMS'
                        : '認証アプリ'
                  }}
                </h5>
                @if (method.type === 'PASSKEY' && method.displayName) {
                  <p>{{ method.displayName }}</p>
                }
                @if (method.type === 'SMS') {
                  <p>{{ method.phoneNumberMasked }}</p>
                }
                @if (method.type === 'PASSKEY') {
                  <p class="caption">
                    最終利用日:
                    {{
                      method.lastUsedAt
                        ? (method.lastUsedAt | date: 'yyyy/MM/dd')
                        : '未使用'
                    }}
                  </p>
                }
                <p class="caption">
                  登録日: {{ method.enrolledAt | date: 'yyyy/MM/dd' }}
                </p>
              </div>
              <button
                rectangle
                variant="secondary"
                [disabled]="busy || cannotRemove()"
                (click)="remove(method.id)"
              >
                削除
              </button>
            </article>
          } @empty {
            <p class="caption">登録済みの手段はありません</p>
          }
        </div>
        @if (cannotRemove() && current.methods.length > 0) {
          <p class="caption remove-hint">
            必須のため、最後の認証手段は削除できません
          </p>
        }
        @if (hasFirebaseMethod && !canAddPasskey) {
          <p class="caption">
            SMS / Authenticator
            を登録している間はパスキーを追加できません(パスキーは組織で有効になっている場合に利用できます)
          </p>
        }
        @if (hasPasskey) {
          <p class="caption">
            SMS / Authenticator を追加するにはパスキーを削除してください
          </p>
        }
        <div class="actions">
          @if (canAddPasskey) {
            <button rectangle [disabled]="busy" (click)="addPasskey()">
              パスキーを追加
            </button>
          }
          @if (canAddSms) {
            <button rectangle [disabled]="busy" (click)="addSms()">
              SMS を追加
            </button>
          }
          @if (canAddTotp) {
            <button rectangle [disabled]="busy" (click)="addTotp()">
              認証アプリを追加
            </button>
          }
        </div>
      }
    </section>
  </div>
</div>
